import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import HeaderWithBack from '../../components/Header/headerWithBack';
import InfoPopupModal from '../../components/infoPopupModal';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import { CLICKED, DINING_RESERVATION_CATEGORY, EXIT, INITIAL_LOADER_SCREEN } from '../../config/Constant';
import { calculateTimeDifference, generateToken, toBool } from '../../utils/Helper';
import { bookEvent, cancelEvent, formatResponseForAvailableEvents, getAllAvailableEvents, getMyEventsReservations, isFirstReservation } from '../../Redux/Actions/reservationAction';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import ReservationEventList from './reservationEventList';
import MyReservations from './myReservations';
import ReservationsAvailability from './reservationsAvailability';
import ReservationsAdditionalInfo from './reservationsAdditionalInfo';
import moment from 'moment';
import ListVenues from './listVenues';
import ReservationsSummary from './reservationsSummary';
import ReservationsSuccess from './reservationsSuccess';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';

export const ClientInfoLS_Key = "eventsReservationClientId";
export const Events_Clients_Details_tempKey="eventsClientsDetails_Temp";

const EventsBooking = () => {
  const { t } = useTranslation();
  const getStyles = useCssStyle();
  const dispatch = useDispatch();

  const { isLoggedIn } = useSelector(state => state.appConfigSlice);
  const { restaurantReservationConfigs } = useSelector(state => state.deviceConfigSlice.webAppWidgetsInfo.appConfigs);
  const { allowWalkInGuestRestaurantBooking } = restaurantReservationConfigs;

  let widgetLaunchTime = new Date;
  const [reservationSessionToken, setReservationSessionToken] = useState(() => generateToken("reservation_"));

  const [currentPage, setCurrentPage] = useState(0);
  const [availableEvents, setAvailableEvents] = useState();
  const [myReservations, setMyReservations] = useState(null);
  const [selectedEvent, setSelectedEvent]=useState(null);

  const [selectedVenue, setSelectedVenue] = useState(null);
  const [inventoryList, setInventoryList]=useState(null)
  const [selectedInventory, setSelectedInventory]=useState(null);

  const [cancelAppointmentId, setCancelAppointmentId] = useState(null);

  const [preferredDateTime, setPreferredDateTime] = useState({ guestCount: '1', date: '' });

  const [additionalInfo, setAdditionalInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    guestComment: '',
    phoneNumber:''
  })

  const [initialLoading, setInitialLoading] = useState(true);
  const [isFetchingMyReservation, setIsfetchingMyReservation] = useState(false);
  const [showLoaderForPromises, setShowLoaderForPromises] = useState(false);
    
  const [loaderState, setLoaderState] = useState({
    showLoader: false,
    loaderMessage: ""
  });

  const [fetchApiError, setFetchApiError] = useState({
      errorStatus: false,
      errorMessage: "",
      onContinueFunc: null,
      primaryBtnLabel: "",
      onCloseFunc: null,
      secondaryBtnLabel: ""
  });


  const toggleLoaderState = (state, message) => {
    setLoaderState({
      showLoader: state,
      loaderMessage: state ? message : ""
    })
  }

  const toggleErrorState = (errorStatus, errorMessage, onContinueFunc=null, primaryBtnLabel, onCloseFunc=null, secondaryBtnLabel) => {
    setFetchApiError({
        errorStatus,
        errorMessage: errorStatus ? errorMessage : "",
        onContinueFunc: errorStatus ? onContinueFunc : null,
        primaryBtnLabel: errorStatus ? primaryBtnLabel : "",
        onCloseFunc: errorStatus ? onCloseFunc : null,
        secondaryBtnLabel: errorStatus ? secondaryBtnLabel : ""
    });
  }

  const fetchMyReservations = async (delay=0) => {
    // if(isFirstReservation()){
    //     setMyReservations([]);
    //     return;
    // }
    toggleErrorState(false);
    
    setIsfetchingMyReservation(true);
 
    setTimeout(async () => {
      try {
        await dispatch(getMyEventsReservations(async (status, data) => {
          if(!status){
            toggleErrorState(true, data || t('events.error.getMyEventsReservations'), ()=> fetchMyReservations(), t('events.buttons.try_again'), () => toggleErrorState(false), t('events.buttons.cancel'));
            
            dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, "FETCH RESERVATIONS - FAILED", { "element": "widget", "widgetSessionId": reservationSessionToken}));
            return;
          }
          const events_= data?.filter((e)=> e.hasOwnProperty("event") &&  e.event!=null);
          setMyReservations(events_);
          if(events_.length>0 && events_[0].clientId){
              await AsyncStorage.setItem(ClientInfoLS_Key,events_[0].clientId)
              await AsyncStorage.removeItem(Events_Clients_Details_tempKey);
          }

          dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, "FETCH RESERVATIONS - SUCCESS", { "element": "widget", "widgetSessionId": reservationSessionToken}));
        }))
      } catch (error) {
        toggleErrorState(true, error?.message || t('events.error.getMyEventsReservations'), ()=> fetchMyReservations(), t('events.buttons.try_again'), () => toggleErrorState(false), t('events.buttons.cancel'));
      } finally {
        setIsfetchingMyReservation(false);
      }
    }, delay * 1000);
  }

  const handleCreateBooking = async () => {
    toggleLoaderState(true, "Booking your event..")

    const payload = {
        "venueId": JSON.parse(selectedVenue).venueId,
        "eventId": selectedEvent.eventId,
        "firstName": isFirstReservation() ? additionalInfo.firstName :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].first_name || ''),
        "lastName":isFirstReservation() ? additionalInfo.lastName :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].last_name || ''),
        "email":  isFirstReservation() ? additionalInfo.email :  (myReservations && myReservations.length>0 && myReservations[0] &&  myReservations[0].email || ''),
        "guestCount": Number(preferredDateTime.guestCount),
        "date": moment(preferredDateTime.date).format("YYYY-MM-DD"),
        "guestComment": additionalInfo.guestComment,
        "inventoryId": JSON.parse(selectedInventory).id,
        "phoneNumber": (isFirstReservation() || myReservations?.[0]?.phone_number=='') ? additionalInfo.phoneNumber :  (myReservations?.[0]?.phone_number || ''),
    }

    try {
      await dispatch(bookEvent(payload, (status, data) => {
        if(!status){
          toggleErrorState(true, data);
           dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, "CREATE BOOKING - FAILED", { "element": "widget", "widgetSessionId": reservationSessionToken}));
          return;
        }
        toggleLoaderState(false)
        handleNext();

        dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, "CREATE BOOKING - SUCCESS", { "element": "widget", "widgetSessionId": reservationSessionToken, "bookingId": data?.reservationId}));
      }))
       
    } catch (error) {
      toggleErrorState(true, error?.message)
    } finally {
    }
    
  }

  const handleDeleteReservationLocal = async (cancelAppointmentId) => {
    toggleLoaderState(true);

    const payload = {
        "reservationId": cancelAppointmentId
    }

    try {
        const { status, message } = await dispatch(cancelEvent(payload));

        if (status) {
            toggleErrorState(true, t('events.success.successful_res_cancelled'))
            dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, "CANCEL RESERVATION - Success", { "element": "widget", "widgetSessionId": reservationSessionToken, "deleteReservationID": cancelAppointmentId}));
        }else{
            toggleErrorState(true, message || t('events.failure.fail_res_cancelled'))
            dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, "CANCEL RESERVATION - ERROR", { "element": "widget", "widgetSessionId": reservationSessionToken, "deleteReservationID": cancelAppointmentId, "errorMessage": message}));
        }
    } catch (err) {
        console.log(err);
    } finally {
      setCancelAppointmentId(null);
      fetchMyReservations(7);
    }

    toggleLoaderState(false);
  };

  const initiateFlow = async () => {
    // toggleLoaderState(true, "Loading...");
    setInitialLoading(true)
    
    const eventsPromise = dispatch(getAllAvailableEvents((status, data) => {
      console.log("available events : ", status, data);


      if(!status){
          toggleErrorState(true, data);
          return;
      }
      const eventsList = formatResponseForAvailableEvents(data);
      setAvailableEvents(eventsList);
    }));

    const reservationsPromise = dispatch(getMyEventsReservations(async (status, data) => {
      console.log("reservations events : ", status, data);
      
      if(!status){
        toggleErrorState(true, data || t('events.error.getMyEventsReservations'), ()=> fetchMyReservations(), t('events.buttons.try_again'), () => toggleErrorState(false), t('events.buttons.cancel'));
        return;
      }
      const events_ = data?.filter((e) => e.hasOwnProperty("event") && e.event != null);
      setMyReservations(events_);
      if (events_.length > 0 && events_[0].clientId) {
        await AsyncStorage.setItem(ClientInfoLS_Key, events_[0].clientId);
        await AsyncStorage.removeItem(Events_Clients_Details_tempKey);
      }
    }));

    const [eventsResult, reservationsResult] = await Promise.allSettled([
      eventsPromise,
      reservationsPromise,
    ]);

    setInitialLoading(false);

    // if (eventsResult.status === "rejected") {
    //   toggleErrorState(
    //     true,
    //     eventsResult.reason?.message || t("events.error.getAvailableEvents"),
    //     () => {
    //       toggleErrorState(false);
    //       initiateFlow();
    //     },
    //     t("events.buttons.retry"),
    //     () => {
    //       toggleErrorState(false);
    //       dispatch(setGoHome(true));
    //     },
    //     t("events.buttons.back")
    //   );
    //   return;
    // }

    // if (reservationsResult.status === "rejected") {
    //   toggleErrorState(
    //     true,
    //     reservationsResult.reason?.message || t("events.error.getMyEventsReservations"),
    //     () => {
    //       toggleErrorState(false);
    //       fetchMyReservations();
    //     },
    //     t("events.buttons.try_again"),
    //     () => toggleErrorState(false),
    //     t("events.buttons.close")
    //   );
    //   return;
    // }
  }

  console.log("current page : ", currentPage);

  const getCurrentPage = () => {
    switch(currentPage) {
      case 0:
        return <ReservationEventList
          availableEvents={availableEvents}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}                      
          handleNext={handleNext}
          handleGoBack={handleGoBack}
        />
      case 1:
        return <MyReservations
          myReservations={myReservations}
          isFetchingMyReservation={isFetchingMyReservation}
          selectedEvent={selectedEvent}
          cancelAppointmentId={cancelAppointmentId}
          setCancelAppointmentId={setCancelAppointmentId}
          handleDeleteReservation={handleDeleteReservationLocal}                           
          fetchMyReservations={fetchMyReservations}
          toggleErrorState={toggleErrorState}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
        />
      case 2:
        return <ListVenues
          selectedEvent={selectedEvent}
          setSelectedVenue={setSelectedVenue}
          selectedVenue={selectedVenue}
          selectedInventory={selectedInventory}
          setSelectedInventory={setSelectedInventory}
          inventoryList={inventoryList}
          setInventoryList={setInventoryList}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
        />
      case 3:
        return <ReservationsAvailability
          selectedEvent={selectedEvent}
          selectedVenue={selectedVenue}
          preferredDateTime={preferredDateTime}
          setPreferredDateTime={setPreferredDateTime}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
        />
      case 4:
        return <ReservationsAdditionalInfo 
          myReservations={myReservations}
          additionalInfo={additionalInfo}
          setAdditionalInfo={setAdditionalInfo}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
        />
      case 5:
        return <ReservationsSummary
          selectedEvent={selectedEvent}
          selectedVenue={selectedVenue}
          selectedInventory={selectedInventory}
          preferredDateTime={preferredDateTime}
          additionalInfo={additionalInfo}
          handleNext={handleCreateBooking}
          handleGoBack={handleGoBack}
        />
      case 6:
        return <ReservationsSuccess 
          selectedEvent={selectedEvent}
          handleNext={handleNext}
          handleGoBack={handleGoBack}
        />
      default:
        return null
    }
  }

  const handleNext = (item) => {
    switch(currentPage){
      case 0:
        setSelectedEvent(item);
        setCurrentPage(1);
        return
      case 6:
        fetchMyReservations();
        setCurrentPage(0);
        return;
      default:
        setCurrentPage(currentPage+1);
        return
    }
  }

  const handleGoBack = () => {
    switch(currentPage){
      case 1:
        setCurrentPage(0);
        return
      default:
        if(currentPage===0){
          dispatch(setGoHome(true));
          return;
        }
        setCurrentPage(currentPage-1);
        return
    }
  }

  useEffect(() => {
    dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, CLICKED, { "element": "widget", "widgetSessionId": reservationSessionToken}));
    // console.log("allowWalkInGuestRestaurantBooking", allowWalkInGuestRestaurantBooking)
    
    if(toBool(allowWalkInGuestRestaurantBooking || isLoggedIn)){
        initiateFlow();
    } else if(!isLoggedIn) {
        dispatch(setGoHome(true));
        dispatch(setShowLoginModal(true));
        return
    }

    return () => {
      const widgetCloseTime = new Date;
      const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
      dispatch(sendAnalytics(DINING_RESERVATION_CATEGORY, EXIT, { "element": "widget", "widgetSessionId": reservationSessionToken, "duration": widgetCloseDuration}));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      
      {getCurrentPage()}

      {fetchApiError.errorStatus && 
        <InfoPopupModal 
            subtitle={fetchApiError.errorMessage} 
            onContinue={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => toggleErrorState(false)}
            primaryBtnLabel={fetchApiError.primaryBtnLabel ? fetchApiError.primaryBtnLabel : "Close"} 
            onClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : null}
            secondaryBtnLabel={fetchApiError.secondaryBtnLabel ? fetchApiError.secondaryBtnLabel : null}
            OnRequestClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : () => toggleErrorState(false)}
        />}

      {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
      {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}

    </>
  )
}

export default EventsBooking
